import { DismissablePromptKey, Experiment } from '@ms/yammer-data/dist/state/types';
import { useLoadDismissablePrompts, useShouldStartDismissablePrompt } from '@ms/yammer-hooks/dist/dismissablePrompts';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { UrlRootPath, getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import React, { ReactNode, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadableAdminPremiumSetupBanner from '../LoadableAdminPremiumSetupBanner';

const promptKeys = [DismissablePromptKey.VivaEngageAdminPremiumSetupBanner];

type UseAdminPremiumSetupBanner = () => ReactNode | null;
export const useAdminPremiumSetupBanner: UseAdminPremiumSetupBanner = () => {
  useLoadDismissablePrompts({ promptKeys });

  const { pathname } = useLocation();
  const urlPath = getUrlRootPath(pathname);
  const isHomeFeedPageUrl = urlPath === UrlRootPath.feed;

  const isAdminBannerPromptNotDismissed = useShouldStartDismissablePrompt(
    DismissablePromptKey.VivaEngageAdminPremiumSetupBanner
  );

  const isAdminBannerExperimentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAdminBanner) === true;

  const shouldDisplayAdminPremiumSetupBanner =
    isHomeFeedPageUrl && isAdminBannerExperimentEnabled && isAdminBannerPromptNotDismissed;

  if (shouldDisplayAdminPremiumSetupBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableAdminPremiumSetupBanner />
      </Suspense>
    );
  }

  return null;
};
